import { inject, Inject, Injectable } from '@angular/core';
import { Store } from '@softline/core';
import {
  AuthorizationStore,
  JwtAuthenticationStore,
  LogoutService,
  SOFTLINE_CONFIG_AUTHENTICATION_ROUTE,
  SOFTLINE_FEATURE_AUTHORIZATION,
  SOFTLINE_FEATURE_JWT_AUTHENTICATION,
} from '@softline/auth';
import { MessageBarStore, SOFTLINE_FEATURE_MESSAGE_BAR } from '@softline/ui-core';
import { Router } from '@angular/router';
import { GuardService } from './guard.service';

@Injectable({
  providedIn: 'root',
})
export class SoftAppsLogoutService extends LogoutService {
  public static GUARD_TYPE = 'SHELL/LOGOUT' as const;

  private guardService = inject(GuardService);

  constructor(
    private store: Store,
    private router: Router,
    @Inject(SOFTLINE_CONFIG_AUTHENTICATION_ROUTE) private loginRoute: string
  ) {
    super();
  }

  async logout(): Promise<void> {
    const guards = this.guardService.guards(SoftAppsLogoutService.GUARD_TYPE);

    const results: boolean[] = [];

    console.log('guards: ', guards);

    for (const guardFn of guards) {
      results.push(await guardFn());
    }

    console.log(results);

    if (results.length > 0 && results.includes(false)) {
      return;
    }

    await this.store.dispatch(
      SOFTLINE_FEATURE_JWT_AUTHENTICATION,
      JwtAuthenticationStore.actions.logout
    );

    await this.store.commit(
      SOFTLINE_FEATURE_AUTHORIZATION,
      AuthorizationStore.mutations.reset
    );

    await this.store.dispatch(
      SOFTLINE_FEATURE_MESSAGE_BAR,
      MessageBarStore.actions.success,
      '#LOGIN.MESSAGES.LOGOUT'
    );

    if (this.router.url.startsWith('/terminal')) return;
    await this.router.navigate([this.loginRoute]);
  }
}
